import React from 'react';
import WeightTracker from '../components/WeightTracker';
import { useClientData } from '../hooks/useClientData';

const ClientWeightPage: React.FC = () => {
  const { clientId, client } = useClientData({
    fetchAppointments: false,
    fetchDietPrograms: false,
    fetchDietitian: false,
  });

  if (!clientId || !client) {
    return null;
  }

  return (
    <WeightTracker
      clientId={clientId}
      clientName={`${client.firstName} ${client.lastName}`}
      client={client}
      isDietitian={false}
    />
  );
};

export default ClientWeightPage;
